<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>액션 활동 관리</h2>
                <button class="default_btn _gray" @click="router.replace('/action/group')">그룹 목록</button>
            </div>

            <div class="sch_condition_wrap" style="margin-top: 5px">
                <div class="left">
                    <div class="select_tab_box_wrap">
                        <span class="sch_list_tit">상태값</span>
                        <div class="select_tab_box _130">
                            <div
                                class="selected_tab"
                                :class="[state.isShowSearchType ? 'active' : '']"
                                @click="state.isShowSearchType = !state.isShowSearchType"
                            >
                                <span>{{ search.searchType.name }}</span>
                            </div>
                            <div class="tab_option">
                                <button
                                    v-for="item in selectOption"
                                    @click="
                                        search.searchType = item;
                                        state.isShowSearchType = false;
                                        getList();
                                    "
                                >
                                    {{ item.name }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="select_tab_box_wrap">
                        <span class="sch_list_tit">제목</span>
                        <div class="select_date_wrap">
                            <div class="search_wrap" style="width: 400px">
                                <input type="text" v-model="search.keyword" @keyup.enter="getList()" placeholder="제목을 입력하세요." />
                                <button type="button" class="search_btn icon_wrap" @click="getList()">
                                    <img src="img/search_btn.png" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <button type="button" class="default_btn _blue" @click="state.isShowStateModal = true">등록</button>
                    <!-- <button type="button" class="default_btn _gray" @click="">삭제</button> -->
                    <button type="button"><img src="img/excel_icon.png" @click="excelDownload" alt=" 엑셀 다운로드" /></button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <!-- <col style="width: 40px" /> -->
                        <col style="width: 80px" />
                        <col />
                        <col style="width: 180px" />
                        <col style="width: 100px" />
                        <col style="width: 120px" />
                        <col style="width: 120px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <!-- <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                <input type="checkbox" v-model="state.isCheckAll" @change="toggleAll()" />
                            </th> -->
                            <th>번호</th>
                            <th>제목</th>
                            <th>활동 기간</th>
                            <th>등록일</th>
                            <th>활동 인원 수</th>
                            <th>활동 수</th>
                            <th>상태</th>
                            <th>상세</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <!-- <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input type="checkbox" :id="'chk_' + item.idx" v-model="state.checkedList" :value="item.idx" @click.stop />
                                        <em></em>
                                    </label>
                                </td> -->
                                <td class="list_num cnt">{{ (state.currentPage - 1) * state.perPage + (idx + 1) }}</td>
                                <td>{{ item.name }}</td>
                                <td class="cnt">
                                    <template v-if="item.startDate && item.endDate">
                                        {{ CommonUtils.dateFormatYYMMDD(new Date(item.startDate)) }} ~
                                        {{ CommonUtils.dateFormatYYMMDD(new Date(item.endDate)) }}
                                    </template>
                                </td>
                                <td class="cnt">{{ CommonUtils.dateFormatYYMMDD(new Date(item.createDate)) }}</td>
                                <td class="cnt">{{ item.cntEntire }}</td>
                                <td class="cnt">{{ item.cntBoard }}</td>
                                <td class="cnt">
                                    <button v-if="item.state === 1" class="default_btn _blue" @click="stateChange(item)">활성화</button>
                                    <button v-else class="default_btn _gray" @click="stateChange(item)">종료</button>
                                </td>
                                <td class="cnt">
                                    <button class="default_btn _blue" @click="router.push(`/action/${state.groupidx}/state/${item.idx}`)">
                                        상세
                                    </button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="8"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.currentPage"
                :totalLength="state.totalLength"
                :perPage="state.perPage"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="modal.tab"
        :title="modal.title"
        :content="modal.content"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>

    <ActionStateModal
        v-if="state.isShowStateModal"
        :idx="state.groupidx"
        @close="state.isShowStateModal = false"
        @callback="closeStateModal"
    ></ActionStateModal>
</template>
<script lang="ts" config>
    import {
        reactive,
        onMounted,
        Header,
        Left,
        ModalDefault,
        AdminManageModal,
        onBeforeUnmount,
        PageBtn,
        CommonUtils,
        router,
        apiService,
        useRoute,
        types,
        getMessageByCode,
        ActionStateModal,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, AdminManageModal: AdminManageModal, ActionStateModal },
        setup() {
            const route = useRoute();
            const state = reactive({
                groupidx: 0 as number,
                selectStateIdx: 0 as number,

                isShowSearchType: false as boolean,
                isShowModal: false as boolean,
                isShowStateModal: false as boolean,

                isCheckAll: false as boolean,
                checkedList: [] as number[],

                list: [] as types.ResActionState[],

                totalLength: 0 as number,
                perPage: 10 as number,
                currentPage: 1 as number,
            });

            const modal = reactive({
                title: "" as string,
                content: "" as string,
                tab: 0 as number,
            });

            const search = reactive({
                startDate: "",
                endDate: "",
                keyword: "",
                searchType: { name: "전체", key: null } as { name: string; key: number | null },
            });

            const selectOption = [
                { name: "전체", key: null },
                { name: "진행중", key: 1 },
                { name: "종료", key: 0 },
            ];

            onMounted(() => {
                if (route.params.groupidx && Number(route.params.groupidx)) {
                    state.groupidx = Number(route.params.groupidx);
                    getList();
                }
            });

            onBeforeUnmount(() => {});

            const getList = async () => {
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    searchType: null,
                    searchText: search.keyword,
                    startDate: search.startDate,
                    endDate: search.endDate,
                    state: search.searchType.key,
                } as types.ReqActionGroupList;
                const res = await apiService.actionState.list(state.groupidx, param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                }
            };

            const searchDate = () => {
                if (search.endDate && search.startDate && search.endDate < search.startDate) {
                    search.endDate = "";
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
                search.startDate = search.startDate;
                search.endDate = search.endDate;
                // state.page = 1;
                getList();
            };

            const toggleAll = () => {};

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getList();
            };

            const callBackModal = (param: any) => {
                if (param.action === "confirm") {
                    toggleState(state.selectStateIdx);
                }
                state.isShowModal = false;
            };

            const closeStateModal = () => {
                state.isShowStateModal = false;
                getList();
            };

            const stateChange = (item: types.ResActionState) => {
                if (item.state === 1) {
                    modal.tab = 5;
                    modal.title = "알림";
                    modal.content = "액션 활동을 종료 하시겠습니까?";
                    state.selectStateIdx = item.idx;
                    state.isShowModal = true;
                } else toggleState(item.idx);
            };

            const toggleState = async (idx: number) => {
                const res = await apiService.actionState.change(state.groupidx, idx);
                if (res.returnCode === 0) {
                    getList();
                } else {
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const excelDownload = async () => {
                try {
                    const param = {
                        idxList: "",
                        page: state.currentPage,
                        size: state.perPage,
                        searchType: search.searchType.key,
                        searchText: search.keyword,
                        state: search.searchType.key,
                        startDate: search.startDate,
                        endDate: search.endDate,
                    } as types.ReqActionGroupForExcel;
                    const res = await apiService.actionState.excelDownload(state.groupidx, param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        modal.tab = -1;
                        modal.title = "알림";
                        modal.content = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            return {
                CommonUtils,
                router,
                state,
                modal,
                search,
                selectOption,
                searchDate,
                toggleAll,
                stateChange,
                handlePageChange,
                callBackModal,
                closeStateModal,
                getList,
                excelDownload,
            };
        },
    };
</script>
<style scoped>
    .sch_condition_wrap > div.right {
        align-items: flex-end;
    }
</style>
